<template>
  <div class="orderCheck">
    <div class="topTitle">请选择需要核销的订单</div>
    <div v-if="hasCheckedOrder">
      <personalCard v-for="item in orders" :key="item.id">
        <div slot="left" class="leftName">
          <el-checkbox v-model="item.checked"></el-checkbox>
        </div>
        <div slot="right" class="rightContent">
          <div class="detail">
            <span class="title">预约时间</span>
            <span class="name">{{item.date}}（{{item.time}}）</span>
          </div>
          <div class="detail">
            <span class="title">参观人数</span>
            <span class="name">{{item.personNum}}</span>
          </div>
        </div>
      </personalCard>
      <div class="buttonNormal" @click="clickCheck">确认核销</div>
    </div>
    <div v-else>
      <!-- <img src="../../assets/"> -->
      <div class="reText">当前时间段无预约，请先预约</div>
      <div class="buttonNormal" @click="toReservation">马上预约</div>
      <div class="buttonConfirm" @click="toIndex">返回主页</div>
    </div>
  </div>
</template>

<script>
import personalCard from '../../components/common/personalCard.vue'
export default {
  data() {
    return {
      orders: [{
        museumName: '超星博物馆',
        date: '2021/04/15',
        time: '9:00-11:00',
        personNum: 1,
        id: 1,
        checked: false
      },{
        museumName: '博物馆',
        date: '2021/04/15',
        time: '9:00-11:00',
        personNum: 1,
        id: 2,
        checked: false
      }],
      hasCheckedOrder: true
    };
  },
  components: {personalCard},

  methods: {
    clickCheck() {
      this.$router.push('/ticket/success?type=check')
    },

    toReservation() {
      this.$router.push('/ticket/reservation')
    },

    toIndex() {
      this.$router.push('/ticket/home')
    }
  },

  created() {
    
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
.orderCheck{
  .topTitle{
    height: 1.5rem;
    background-color: #f6f6f6;
    line-height: 1.5rem;
    font-size: 0.45rem;
    font-weight: 500;
  }
  .detail{
    .title{
      margin-right: 0.3rem;
    }
  }
  .reText{
    font-size: 0.6rem;
    font-weight: 500;
    margin: 0.5rem 0 1rem 0;
  }
  .buttonNormal{
    margin-top: 1rem;
  }
}
</style>
<style type="text/css" lang="scss">
.orderCheck{
  .el-checkbox__inner{
    border-radius: unset !important;
    margin-top: 0.8rem;
  }
}
</style>
